// This file is auto-generated by the generateModuleTranslationKeys Vite plugin.
// Do not edit this file manually.
import { useTypedTranslation } from "@/shared/culture/useTypedTranslation";
import { useTranslationModule } from "./moduleTranslations";

export const AUTH_TRANSLATIONS = {
  "common.or": "OR",
  "errorContent.defaultMessage":
    "It seems there was an issue with the request. Please verify that the necessary parameters are correctly set. If the problem persists, feel free to reach out to our support team for assistance.",
  "errorContent.titlePrefix": "Error",
  "errors.failedToDecodeRegistrationCode":
    "Failed to decode registration code.",
  "errors.invalidRegistrationCode": "Invalid registration code",
  "errors.notFound": "404 Not Found",
  "errors.pageNotFound": "The page you are looking for does not exist.",
  "errors.registerStateFailedTryAgain": "An error occurred, please try again.",
  "errors.registrationFailedTryAgain": "Registration failed, please try again.",
  "errors.title": "Error",
  "errors.unexpected": "An unexpected error occurred.",
  "errors.unknownError": "Unknown Error",
  "login.mfaCode": "MFA Code",
  "login.password": "Password",
  "login.usernameOrEmail": "Username / Email",
  "mfa.mfaCode": "MFA code",
  "mfa.orUseQrCode": "or use QR code",
  "mfa.orUseSetupCode": "or use setup code",
  "mfa.qrCode": "QR Code",
  "mfa.setupCode": "Setup code",
  "migrate.microsoftAuthRequired": "Microsoft Auth Required",
  "migrate.microsoftAuthRequiredDescription":
    "The company this account is registered in now requires users to authenticate using a Microsoft account. To continue using our services seamlessly, please link your current account to a Microsoft account. After clicking 'Yes', your email address will become your username.",
  "migrate.microsoftAuthRequiredPrompt":
    "Would you like to couple this account to your Microsoft account now?",
  "migrate.title": "Migrate",
  "register.acceptThe": "I accept the",
  "register.confirmPassword": "Confirm Password",
  "register.enableMfa": "Enable MFA",
  "register.password": "Password",
  "register.passwordsMustMatch": "Passwords must match",
  "register.securityQuestionsPrefix": "For security-related questions, see our",
  "register.username": "Username",
  "validation.login.passwordMin": "Password must have at least 3 characters",
  "validation.login.usernameOrEmailMin":
    "Username / Email must have at least 3 characters",
  "validation.register.acceptPrivacyPolicyRequired":
    "You must accept the Privacy Policy",
  "validation.register.acceptTermsOfUseRequired":
    "You must accept the Terms of Use",
  "validation.register.confirmPasswordRequired": "Please confirm your password",
  "validation.register.passwordMin": "Minimum 8 characters",
  "validation.register.passwordsDoNotMatch": "Passwords do not match",
} as const;

export const AUTH_PLURAL_KEYS = {} as const;

export type AuthTranslationKey = keyof typeof AUTH_TRANSLATIONS;
export type AuthPluralTranslationKey = keyof typeof AUTH_PLURAL_KEYS;

/**
 * Typed translation hook for auth-specific keys.
 * For shared/global keys, use useCommonTranslation() instead.
 */
export function useAuthTranslation() {
  const isReady = useTranslationModule("auth", { waitForReady: true });
  return useTypedTranslation<
    AuthTranslationKey,
    typeof AUTH_TRANSLATIONS,
    AuthPluralTranslationKey
  >(AUTH_TRANSLATIONS, AUTH_PLURAL_KEYS, { isReady });
}
